var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout",
    [
      _c(
        "b-container",
        [
          _c("loading", {
            attrs: {
              active: _vm.isLoading,
              "can-cancel": false,
              "is-full-page": true
            },
            on: {
              "update:active": function($event) {
                _vm.isLoading = $event
              }
            }
          }),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { lg: "8", "offset-lg": "2" } },
                [
                  _c("system-details", {
                    attrs: { system: _vm.system, type: "credit", compact: true }
                  }),
                  _vm._v(" "),
                  this.role === "EllipseAdmin" ||
                  this.role === "CreditDistributor"
                    ? _c(
                        "div",
                        [
                          _c("b-row", [
                            _c(
                              "div",
                              { attrs: { id: "system-credit-header" } },
                              [
                                _c("h1", {}, [
                                  _vm._v(_vm._s(_vm.$t("titles.systemcredit")))
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.errors.response.list, function(error) {
                            return _c(
                              "b-alert",
                              {
                                key: error.Message,
                                attrs: {
                                  show: "",
                                  dismissible: "",
                                  variant: "danger"
                                }
                              },
                              [_vm._v(_vm._s(error.Message))]
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      staticClass: "pretty-padding",
                                      model: {
                                        value: _vm.useCredits,
                                        callback: function($$v) {
                                          _vm.useCredits = $$v
                                        },
                                        expression: "useCredits"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("buttons.credits")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      staticClass: "pretty-padding",
                                      model: {
                                        value: _vm.useTime,
                                        callback: function($$v) {
                                          _vm.useTime = $$v
                                        },
                                        expression: "useTime"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("buttons.time")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          this.useCredits
                            ? _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "fieldsetHorizontal",
                                    horizontal: "",
                                    "label-cols": 4,
                                    label: _vm.$t("labels.credits"),
                                    "label-for": "credits"
                                  }
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: { options: _vm.creditOptions },
                                    nativeOn: {
                                      change: function($event) {
                                        return _vm._flush.apply(null, arguments)
                                      }
                                    },
                                    model: {
                                      value: _vm.credits,
                                      callback: function($$v) {
                                        _vm.credits = _vm._n($$v)
                                      },
                                      expression: "credits"
                                    }
                                  }),
                                  _vm._v(" "),
                                  this.errors.credits
                                    ? _c(
                                        "label",
                                        { staticClass: "error-label force-up" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "errors.credits_required"
                                                )
                                              ) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          this.useTime
                            ? _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "fieldsetHorizontal",
                                    horizontal: "",
                                    "label-cols": 4,
                                    label: _vm.$t("labels.time"),
                                    description: _vm.$tc(
                                      "labels.selectedTime",
                                      _vm.selectedTime
                                    ),
                                    "label-for": "time"
                                  }
                                },
                                [
                                  _c(
                                    "b-input-group",
                                    {
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "append",
                                            fn: function() {
                                              return [
                                                _c(
                                                  "b-input-group-text",
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "calendar-alt"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        false,
                                        2375244713
                                      )
                                    },
                                    [
                                      _c("flat-pickr", {
                                        staticClass:
                                          "form-control force-enabled",
                                        attrs: {
                                          name: "time",
                                          config: _vm.dateSelectConfig
                                        },
                                        on: { "on-close": _vm._flush },
                                        model: {
                                          value: _vm.time,
                                          callback: function($$v) {
                                            _vm.time = $$v
                                          },
                                          expression: "time"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  this.errors.time
                                    ? _c(
                                        "label",
                                        { staticClass: "error-label force-up" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t("errors.time_required")
                                              ) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.useCredits
                            ? _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "fieldsetHorizontal",
                                    horizontal: "",
                                    "label-cols": 4,
                                    label: _vm.$t("labels.licenseaction"),
                                    "label-for": "licenseActionType"
                                  }
                                },
                                [
                                  _c("b-form-select", {
                                    staticClass: "mb-3",
                                    attrs: {
                                      id: "licenseActionType",
                                      options: _vm.licenseActionTypes
                                    },
                                    model: {
                                      value: _vm.selectedLicenseActionType,
                                      callback: function($$v) {
                                        _vm.selectedLicenseActionType = $$v
                                      },
                                      expression: "selectedLicenseActionType"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                label: _vm.$t("labels.transactionid"),
                                description: _vm.$t("labels.mandatory"),
                                "label-for": "transactionId"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "transactionId" },
                                model: {
                                  value: _vm.transactionId,
                                  callback: function($$v) {
                                    _vm.transactionId = $$v
                                  },
                                  expression: "transactionId"
                                }
                              }),
                              _vm._v(" "),
                              this.errors.transactionId
                                ? _c(
                                    "label",
                                    { staticClass: "error-label force-up" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t(
                                              "errors.transactionId_required"
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                label: _vm.$t("labels.note"),
                                "label-for": "note"
                              }
                            },
                            [
                              _c("b-form-textarea", {
                                attrs: { id: "note" },
                                model: {
                                  value: _vm.note,
                                  callback: function($$v) {
                                    _vm.note = $$v
                                  },
                                  expression: "note"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "pt-2", attrs: { "align-h": "between" } },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "min-width-button",
                          attrs: {
                            type: "button",
                            variant: "outline-secondary",
                            "active-class": "",
                            to: {
                              name: "system-credits-overview",
                              params: { logosid: this.system.LogosID }
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("buttons.back")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "min-width-button",
                          attrs: {
                            type: "submit",
                            variant: "outline-secondary",
                            "active-class": "",
                            disabled: !_vm.creditFileEnabled
                          },
                          on: { click: _vm.save }
                        },
                        [_vm._v(_vm._s(_vm.$t("buttons.continue")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "complete",
          attrs: {
            "hide-footer": "",
            title: _vm.modalTitle,
            "hide-header-close": ""
          }
        },
        [
          this.useCredits
            ? _c("div", { attrs: { "hide-footer": "" } }, [
                _vm._v(
                  "  \n      " +
                    _vm._s(
                      _vm.$t("texts.complete.credits", {
                        systemtype: _vm.$t(
                          "systemtypes." + this.system.SystemPartNumber
                        ),
                        serialnumber: this.system.SerialNumber,
                        location: this.system.Location,
                        numberOfCredits: this.credits,
                        price: this.price.Price,
                        currency: this.price.Currency
                      })
                    ) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          this.useTime
            ? _c("div", [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("texts.complete.time", {
                        systemtype: _vm.$t(
                          "systemtypes." + this.system.SystemPartNumber
                        ),
                        serialnumber: this.system.SerialNumber,
                        location: this.system.Location,
                        time: ((_vm.files.credit || {}).CreditFile || {})
                          .Amount,
                        price: this.price.Price,
                        currency: this.price.Currency
                      })
                    ) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("divider"),
          _vm._v(" "),
          _c(
            "b-form-checkbox",
            {
              staticClass: "pt-4",
              attrs: {
                "aria-describedby": "send mail",
                "aria-controls": "send mail"
              },
              model: {
                value: _vm.sendCreditFileOnMail,
                callback: function($$v) {
                  _vm.sendCreditFileOnMail = $$v
                },
                expression: "sendCreditFileOnMail"
              }
            },
            [
              this.useCredits
                ? _c("div", { attrs: { "hide-footer": "" } }, [
                    _vm._v(
                      "  \n        " +
                        _vm._s(_vm.$t("texts.sendmail.credits")) +
                        " " +
                        _vm._s(_vm.email) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.useTime
                ? _c("div", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("texts.sendmail.time")) +
                        " " +
                        _vm._s(_vm.email) +
                        "\n      "
                    )
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("divider"),
          _vm._v(" "),
          _c(
            "b-btn",
            {
              staticClass: "mt-3",
              attrs: { block: "", variant: "outline-success" },
              on: { click: _vm.confirm }
            },
            [_vm._v(_vm._s(_vm.$t("buttons.ok")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10e98712", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10e98712","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./WebApp/components/IssueSystemCredits.vue
// module id = 762
// module chunks = 0